import React, { FC } from 'react'
import styles from './SwitchCheckbox.module.css'
import cn from 'classnames'

export const SwitchCheckbox: FC<React.HTMLProps<HTMLInputElement>> = (
  props
) => {
  return (
    <div
      {...props}
      className={cn(props.className, styles.root, {
        [styles.selected]: props.checked
      })}
    >
      <div className={styles.handle} />
      <input
        {...{ ...props, children: undefined }}
        type='checkbox'
        className={styles.hiddenInput}
      />
    </div>
  )
}
